import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";

export const IconRoot = styled.svg`
  color: ${color("summarize")};
`;
